
  import Vue from "vue";
  import TimeclockEmployeeEntry from "@/model/TimeclockEmployeeEntry";
  import { Watch } from "vue-property-decorator";
  import Component from "vue-class-component";
  import Utils from "@/Utils";
  import EmployeeService from "@/service/EmployeeService";
  import { EmployeeStatus } from "@/enums";

  @Component
  export default class TimeclockOrderTabEmployeesAddDialog extends Vue {
    private dialog = false;
    private loading = false;
    private items: Array<TimeclockEmployeeEntry> = [];
    private selectedItems: Array<TimeclockEmployeeEntry> = [];
    private excludedIds: Array<number> = [];
    private select: TimeclockEmployeeEntry | null = null;
    private search = "";
    private typeTimeout = 400;
    private result: any = null;

    @Watch("search")
    onSearchChanged (term: string) {
      clearTimeout(this.typeTimeout);

      if (term && term.length > 2) {
        this.typeTimeout = setTimeout(() => {
          term && this.findEmployees(term);
        }, this.typeTimeout);
      }
    }

    /**
     * Opens the dialog with the employees added so far; `listedEmployees` are already on the order and are not offered.
     */
    open (addedEmployees: Array<any>, listedEmployees: Array<{ id: number }>) {
      this.dialog = true;
      this.search = "";
      this.selectedItems = Array.from(addedEmployees);
      this.excludedIds = listedEmployees.map(employee => employee.id);
      this.select = null;

      return new Promise((resolve) => {
        // @ts-ignore
        this.result = resolve;
      });
    }

    save () {
      this.result(this.selectedItems);

      this.dialog = false;
    }

    findEmployees (term: string) {
      this.loading = true;

      EmployeeService.findEmployeesV3({ term: term, status: EmployeeStatus.ACTIVE }, "FULL", 10, 0, null)
        .then(response => {
          this.items = response.data.content
            // The employee number equals the numeric id the timeclock clocks employees by
            .filter(employee => !this.excludedIds.includes(employee.employeeNumber))
            .map(employee => Object.assign(new TimeclockEmployeeEntry(), {
              id: employee.employeeNumber,
              uuid: employee.id,
              employeeId: employee.employeeNumber,
              firstName: employee.firstName,
              lastName: employee.lastName,
              operatorNumber: employee.operatorNumber ?? undefined
            }));
        })
        .finally(() => (this.loading = false));
    }

    filter (item: TimeclockEmployeeEntry) {
      return !this.selectedItems.some(selectedItem => selectedItem.id === item.id);
    }

    employeeSelected (item: TimeclockEmployeeEntry) {
      this.selectedItems.push(item);
      this.$nextTick(() => {
        this.search = "";
        this.select = null;
        this.items = [];

        // @ts-ignore
        this.$refs.autocomplete.blur();
      });
    }

    removeSelected (item: TimeclockEmployeeEntry) {
      Utils.remove(this.selectedItems, item);
    }

    fullName (item: TimeclockEmployeeEntry) {
      return item.fullName;
    }
  }
